// In-memory draft store (Step C Part 6). A submit that 401s refreshes once and retries once; if that
// retry still fails the session ends honestly and the desk unmounts to sign-in. This keeps the owner's
// typed text alive IN MEMORY across that unmount so it is restored the moment they sign back in — and
// it NEVER touches localStorage/sessionStorage or any cookie. Plain JS memory: cleared on a full page
// reload and on a successful submit.
//
// Account-scoped (fix): drafts are keyed by account id and restored ONLY to the same account. If a
// DIFFERENT account signs in on the same tab, every held draft is wiped first — one person's typed
// text can never surface for another.
const _drafts = new Map();      // key: `${accountId}::${localKey}` -> text
let _owner = null;              // account id whose drafts are currently held

export function bindDraftOwner(accountId) {
  if (!accountId) return;
  if (_owner && accountId !== _owner) _drafts.clear();   // a different account signed in → wipe
  _owner = accountId;
}

export const getDraft = (accountId, localKey) =>
  (accountId ? _drafts.get(accountId + "::" + localKey) : "") || "";

export const setDraft = (accountId, localKey, val) => {
  if (!accountId) return;
  const k = accountId + "::" + localKey;
  if (val) _drafts.set(k, val); else _drafts.delete(k);
};

export const clearDraft = (accountId, localKey) => {
  if (accountId) _drafts.delete(accountId + "::" + localKey);
};
